import { gql } from '@apollo/client';

export const ADD_INSPECTION = gql`
  mutation AddInspection($regionId: String!, $inspection: InspectionInput!) {
    addInspection(regionId: $regionId, inspection: $inspection) {
      id
      apn
      inspectionTime
      submissionTime
    }
  }
`;
